const entryCreate = require('./contentful/entry-create');
const EntryService = require('../services/EntryService').default;
const getSpace = require('./contentful/get-space');
const transformer = require('./transformers/warrantyPeriod');
const linkResolve = require('./contentful/link-resolve');
const processError = require('./contentful/error-process');

let entryService = null;

const gettingEntryService = () => {
  if (!entryService) {
    entryService = getSpace().then((space) => {
      return new EntryService(space, transformer);
    });
  }

  return entryService;
};

const createWarrantyPeriod = (space, warrantyPeriod, depth) => {
  const data = transformer.internalToContentful(warrantyPeriod);
  return entryCreate(space, 'warrantyPeriod', data).then((entry) => {
    return entry;
  }).then((entry) => {
    const data = entry.toPlainObject();
    return linkResolve(space, data, depth);
  }).then((data) => {
    return transformer.contentfulToInternal(data);
  });
};

module.exports = {
  getByMakeId(makeId, depth = 0) {
    return getSpace().then((space) => {
      return space.getEntries({
        'content_type': 'warrantyPeriod', // eslint-disable-line
        'fields.make.sys.id': makeId
      }).catch(
        processError
      ).then((entries) => {
        return linkResolve(space, entries, depth).then((entries) => {
          return entries.items.map(transformer.contentfulToInternal);
        });
      });
    });
  },

  getByParams(params, depth = 0) {
    return getSpace().then((space) => {
      return space.getEntries(
        params
      ).catch(
        processError
      ).then((entries) => {
        return linkResolve(space, entries, depth).then((entries) => {
          return entries.items.map(transformer.contentfulToInternal);
        });
      });
    });
  },

  createEmpty() {
    return {
      published: false,
      updated: false,
      draft: true,

      title: '',
      fromDate: null,
      toDate: null,
      electric: false,
      van: false,
      make: null,
      model: null,
      warrantyDocument: null,
      standardWarrantyText: '',
      paintWarrantyText: '',
      rustWarrantyText: '',
      batteryWarrantyText: '',
      jsonReg: [],
      jsonBattery: []
    };
  },

  getById(...parameters) {
    return gettingEntryService().then((service) => service.getById(...parameters));
  },

  new(warrantyPeriod, depth = 0) {
    return getSpace().then((space) => {
      return createWarrantyPeriod(space, warrantyPeriod, depth);
    });
  },

  save(...parameters) {
    return gettingEntryService().then((service) => service.save(...parameters));
  },

  publish(...parameters) {
    return gettingEntryService().then((service) => service.publish(...parameters));
  },

  unpublish(...parameters) {
    return gettingEntryService().then((service) => service.unpublish(...parameters));
  },

  archive(...parameters) {
    return gettingEntryService().then((service) => service.archive(...parameters));
  },

  unarchive(...parameters) {
    return gettingEntryService().then((service) => service.unarchive(...parameters));
  }
};
